import { configureStore } from "@reduxjs/toolkit";
import documentsReducer from "./documentsSlice";
import themeReducer from "./themeSice"

export const store = configureStore({
  reducer: {
    documents: documentsReducer,
    theme: themeReducer
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;